import { Component } from '@angular/core';
import {TranslateService} from 'ng2-translate';
import {environment} from "./../environments/environment";
@Component({
  selector: 'my-app',
  template: ` <router-outlet></router-outlet> `
})
export class AppComponent {

  constructor(translate: TranslateService) {
        // this language will be used as a fallback when a translation isn't found in the current language
       // translate.setDefaultLang('en');

         // the lang to use, if the lang isn't available, it will use the current loader to get them


       
        let browserLang = translate.getBrowserLang();
        translate.use(environment.lng);//browserLang.match(/en|bg/) ? browserLang : 'en');
    }
 }



// WEBPACK FOOTER //
// /app/src/app/app.component.ts